import React, { createContext, useContext, useEffect, useState } from 'react';
import { login as apiLogin, me as apiMe } from '../services/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ldc_token');
    if (!token) {
      setLoading(false);
      return;
    }
    apiMe()
      .then((u) => setUser(u))
      .catch(() => localStorage.removeItem('ldc_token'))
      .finally(() => setLoading(false));
  }, []);

  const signIn = async (username, password) => {
    const { access_token } = await apiLogin(username, password);
    localStorage.setItem('ldc_token', access_token);
    const u = await apiMe();
    setUser(u);
    return u;
  };

  const signOut = () => {
    localStorage.removeItem('ldc_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};
